import React, { useState, useEffect } from "react"
import { db } from "../../../firebaseClient"
import { collection, getCountFromServer, query, orderBy, limit, onSnapshot } from "firebase/firestore"
import Icon from "../../../components/AppIcon"

const SEVERITY_COLOR = {
  info: "text-muted-foreground",
  warning: "text-warning",
  critical: "text-destructive",
}

const formatEventType = (type) => {
  return (type || "")
    .split("_")
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ")
}

const formatTimestamp = (ts) => {
  const ms = ts?.toMillis ? ts.toMillis() : null
  if (!ms) return ""
  return new Date(ms).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })
}

const OverviewPanel = () => {
  const [orgCount, setOrgCount] = useState(null)
  const [events, setEvents] = useState([])
  const [eventsLoading, setEventsLoading] = useState(true)

  useEffect(() => {
    const loadCounts = async () => {
      try {
        const snap = await getCountFromServer(collection(db, "organizations"))
        setOrgCount(snap.data().count)
      } catch (error) {
        setOrgCount(null)
      }
    }
    loadCounts()
  }, [])

  useEffect(() => {
    const q = query(collection(db, "events"), orderBy("createdAt", "desc"), limit(20))
    const unsubscribe = onSnapshot(
      q,
      (snap) => {
        setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
        setEventsLoading(false)
      },
      (error) => {
        setEventsLoading(false)
      }
    )
    return () => unsubscribe()
  }, [])

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-card border border-border rounded-xl p-4">
          <p className="text-sm text-muted-foreground">Organizations</p>
          <p className="text-2xl font-bold text-foreground mt-1">
            {orgCount === null ? "—" : orgCount.toLocaleString()}
          </p>
        </div>
      </div>

      <div className="bg-card border border-border rounded-xl overflow-hidden">
        <div className="px-4 py-3 border-b border-border">
          <h2 className="font-semibold text-foreground">Live Platform Activity</h2>
        </div>

        {eventsLoading ? (
          <div className="p-6 text-center text-muted-foreground text-sm">Loading activity...</div>
        ) : events?.length === 0 ? (
          <div className="p-6 text-center text-muted-foreground text-sm">No events yet.</div>
        ) : (
          <div className="divide-y divide-border">
            {events?.map((event) => (
              <div key={event?.id} className="px-4 py-3 flex items-start gap-3">
                <span className={`mt-1 size-2 rounded-full shrink-0 ${
                  event?.severity === "critical" ? "bg-destructive" :
                  event?.severity === "warning" ? "bg-warning" : "bg-success"
                }`} />
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-foreground">
                    {formatEventType(event?.type)}
                  </p>
                  {event?.orgId && (
                    <p className="text-xs text-muted-foreground truncate">Org: {event.orgId}</p>
                  )}
                </div>
                <span className="text-xs text-muted-foreground shrink-0">
                  {formatTimestamp(event?.createdAt)}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default OverviewPanel